src/components/Post.vue
<template>
  <div class="privacy">
    <a id="back" @click="back()">戻る</a>
    <img src="@/assets/privacy01.jpg" />
    <img src="@/assets/privacy02.jpg" />
  </div>
</template>

<script>
export default {
  name: "nomatch",
  data: () => ({}),
  methods: {
    back: function() {
      this.$router.go(-1);
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.privacy {
}
img {
  margin-top: 0px;
  min-width: 100px;
  width: 100%;
  max-width: 750px;
}
h1,
h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
a {
  color: #42b983;
  cursor: pointer;
}
input {
  margin: 10px;
  padding: 10px;
}
#back {
  margin-right: 80%;
  text-align: center;
}
</style>